// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field[data-v-06d15f5f]{border-radius:5px}.credit-card[data-v-06d15f5f]{margin:0 auto;padding:30px;width:100%}.copyAndPayForm[data-v-06d15f5f]{max-width:450px;min-width:450px}.copyAndPayForm .wpwl-control input[data-v-06d15f5f],.copyAndPayForm .wpwl-group-cardNumber[data-v-06d15f5f]{height:70px!important}@media screen and (max-width:767px){.new-card .copyAndPayForm[data-v-06d15f5f]{min-width:50px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
